import '../../scss/pages/login.scss';
import { ResolveNIP } from "../libraries/ResolveNIP";

/**
 * @param {string} password
 * @return {boolean}
 */
function containLowercase(password) {
    const filter = new RegExp(/[a-z]/g);
    return filter.test(password);
}

/**
 * @param {string} password
 * @return {boolean}
 */
function containUppercase(password) {
    const filter = new RegExp(/[A-Z]/g);
    return filter.test(password);
}

/**
 * @param {string} password
 * @return {boolean}
 */
function containNumbers(password) {
    const filter = new RegExp(/[0-9]/g);
    return filter.test(password);
}

/**
 * @param {string} password
 * @return {boolean}
 */
function minLenght(password) {
    if (password.length >= 8) {
        return true;
    } else {
        return false;
    }
}

function initializeToggleShowPassword() {

  let buttonsElement = document.querySelectorAll('button[name=show-hide-password-button]');

  if (buttonsElement != null) {
    buttonsElement.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        let inputElement = button.parentElement.querySelector('input[type=password]');
        if (inputElement != null) {
          if (inputElement.type === 'password') {
            inputElement.type = 'text';
          } else {
            inputElement.type = 'password';
          }
        }
      });
    });
  }

}

function initializeDetectStrongPassword() {
    const inputPassword = document.querySelector('input[name=u_haslo1]');

    if (!inputPassword) {
        return
    }

    inputPassword.addEventListener('keyup', (event) => {
        const div = inputPassword.parentElement;
        const passwordLevelUppercase = div.querySelector('.password-level-uppercase');
        const passwordLevelLowercase = div.querySelector('.password-level-lowercase');
        const passwordLevelMinChar = div.querySelector('.password-level-min-char');
        const passwordLevelNumber = div.querySelector('.password-level-number');

        if (passwordLevelUppercase && containUppercase(inputPassword.value)) {
            passwordLevelUppercase.classList.add('passed');
        } else {
            passwordLevelUppercase.classList.remove('passed');
        }

        if (passwordLevelLowercase && containLowercase(inputPassword.value)) {
            passwordLevelLowercase.classList.add('passed');
        } else {
            passwordLevelLowercase.classList.remove('passed');
        }

        if (passwordLevelMinChar && minLenght(inputPassword.value)) {
            passwordLevelMinChar.classList.add('passed');
        } else {
            passwordLevelMinChar.classList.remove('passed');
        }

        if (passwordLevelNumber && containNumbers(inputPassword.value)) {
            passwordLevelNumber.classList.add('passed');
        } else {
            passwordLevelNumber.classList.remove('passed');
        }
    });
}

function initialize() {
  initializeDetectStrongPassword();
  initializeToggleShowPassword();
}

document.addEventListener('DOMContentLoaded', initialize);
